import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, ListItemIcon, ListItemText } from "@mui/material";
import { Delete, InfoRounded } from "@mui/icons-material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { CheckHasAnyPermission, CheckHasPermission } from "./Common_functions";

export default function BasicMenu({
  onEdit,
  onDelete,
  onDetails,
  onAdd,
  detailsName,
  editName,
  addName,
  deleteName,
  extra,
  checkSubMenuPermission,
  checkActionPermission,
  actionCode,
  subMenuCode,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const canCreate=checkSubMenuPermission? CheckHasPermission(subMenuCode, "create"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canRead=checkSubMenuPermission? CheckHasPermission(subMenuCode, "read"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canUpdate=checkSubMenuPermission? CheckHasPermission(subMenuCode, "update"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canDelete=checkSubMenuPermission? CheckHasPermission(subMenuCode, "delete"):checkActionPermission?CheckHasAnyPermission(actionCode):true
  const canViewMenu=canCreate||canDelete||canUpdate||canDelete||canRead||extra

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
     
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
    {canViewMenu?
      <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {extra
        ?.filter((v) => v)
        ?.map((v) => (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              handleClose();
              if (v.onClick && typeof v.onClick === "function") {
                v.onClick();
              }
            }}
          >
            <ListItemIcon>
              {v.icon ?? <InfoRounded fontSize="small" />}
            </ListItemIcon>
            <ListItemText>{v.label}</ListItemText>
          </MenuItem>
        ))}

      {onDetails&&canRead ? (
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleClose();
            if (onDetails && typeof onDetails === "function") {
              onDetails();
            }
          }}
        >
          <ListItemIcon>
            <InfoRounded fontSize="small" />
          </ListItemIcon>
          <ListItemText>{detailsName ? detailsName : "Details"}</ListItemText>
        </MenuItem>
      ) : null}
      {onEdit && canUpdate ? (
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleClose();
            if (onEdit && typeof onEdit === "function") {
              onEdit();
            }
          }}
        >
          <ListItemIcon>
            <BorderColorIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{editName ? editName : "Edit"}</ListItemText>
        </MenuItem>
      ) : null}
      {onDelete &&canDelete ? (
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleClose();
            if (onDelete && typeof onDelete === "function") {
              onDelete();
            }
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" color={"error"} />
          </ListItemIcon>
          <ListItemText>{deleteName ? deleteName : "Delete"}</ListItemText>
        </MenuItem>
      ) : null}
      {onAdd &&canCreate ? (
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleClose();
            if (onAdd && typeof onAdd === "function") {
              onAdd();
            }
          }}
        >
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{addName ? addName : "Add"}</ListItemText>
        </MenuItem>
      ) : null}
    </Menu>
    :null}
    </div>
  );
}
